// @flow
import React from 'react';
import logger from '../../utils/clientLogger';
import Oops from './FallbackComponent';

import {ErrorReportBoundary} from '@homeaway/react-error-reporter';

import type {Node} from 'react';

type Props = {
    children: Node,
    errrorName?: string
};

export const OOPS_ERROR_NAME = 'Oops unable to load results';

export default function ErrorBoundary({
    children,
    errrorName = OOPS_ERROR_NAME
}: Props) {
    return (
        <ErrorReportBoundary
            fallbackUI={<Oops />}
            name={errrorName}
            onError={(error, info) => {
                logger.captureException(error, {extra: info});
            }}
        >
            {children}
        </ErrorReportBoundary>
    );
}
